<div class="bg-shui-base-2 rounded-md">
    <header class="flex items-center justify-between border-solid border-0 border-b-2 border-b-shui-base-4 p-4">
        <span class="text-base text-shui-text-strong font-semibold">{{
            'common.contact-dialog.title' | translate
        }}</span>
        <sh-button (click)="close()" icon="cancel" layout="normal" color="secondary" size="s"></sh-button>
    </header>
    <main class="p-4">
        <p class="text-shui-text-strong">{{ 'contact-dialog.description' | translate }}</p>
    </main>

    <div class="flex justify-end items-center p-4">
        <sh-button
            [label]="'common.close' | translate"
            layout="normal"
            color="secondary"
            size="m"
            (click)="close()"
        ></sh-button>
    </div>
</div>
